import React from "react";
import cx from "classnames";
import useSheet from "react-jss";
import PropTypes from "prop-types";

export const END_ALIGN = "end";
export const START_ALIGN = "start";
export const CENTER_ALIGN = "center";

const enhancer = useSheet({
  root: {
    margin: 0,
    display: "flex",
    padding: "16px",
    borderTop: "1px solid #ccc"
  },
  msDisplayFlex: {
    display: "-ms-flexbox"
  },
  [`${START_ALIGN}-align`]: {
    justifyContent: "flex-start"
  },
  [`${CENTER_ALIGN}-align`]: {
    justifyContent: "center"
  },
  [`${END_ALIGN}-align`]: {
    justifyContent: "flex-end"
  }
});

DialogActions.propTypes = {
  classes: PropTypes.object,

  className: PropTypes.string,

  children: PropTypes.node.isRequired,
  align: PropTypes.oneOf([START_ALIGN, CENTER_ALIGN, END_ALIGN])
};

DialogActions.defaultProps = {
  align: END_ALIGN
};

function DialogActions(props) {
  const { classes } = props;

  return (
    <div
      className={cx(
        classes.root,
        classes.msDisplayFlex,
        classes[`${props.align}-align`],
        props.className
      )}
    >
      {props.children}
    </div>
  );
}

export default enhancer(DialogActions);



// WEBPACK FOOTER //
// ./src/module/components/DialogActions.js